(function () {
  'use strict';

  function init(root) {
    if (root.dataset.khInit === '1') return;
    root.dataset.khInit = '1';

    var strip = root.querySelector('[data-kh-strip]');
    var prev = root.querySelector('[data-kh-prev]');
    var next = root.querySelector('[data-kh-next]');
    if (!strip || (!prev && !next)) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      var item = strip.querySelector('.karehero__item');
      var gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
      var one = item ? item.getBoundingClientRect().width + gap : strip.clientWidth * 0.8;
      var kac = Math.max(1, Math.floor(strip.clientWidth / one));
      return one * kac;
    }

    function scrollBy(dir) {
      strip.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    function sync() {
      var max = strip.scrollWidth - strip.clientWidth;
      if (prev) prev.hidden = strip.scrollLeft <= 2;
      if (next) next.hidden = strip.scrollLeft >= max - 2;
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
    strip.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* Kampanya kartı ölçüleri kart genişliğine bağlı (--u = %1). cqw'yu
     tanımayan tarayıcılarda --u'yu burada piksel olarak yazıyoruz. */
  var cqwVar = window.CSS && CSS.supports && CSS.supports('width', '1cqw');
  function olcKampanya(root) {
    if (cqwVar) return;
    var kartlar = root.querySelectorAll('.khk');
    if (!kartlar.length) return;
    function olc() {
      kartlar.forEach(function (k) {
        var w = k.getBoundingClientRect().width;
        if (w > 0) k.style.setProperty('--u', (w / 100) + 'px');
      });
    }
    olc();
    window.addEventListener('resize', olc);
    window.addEventListener('load', olc);
  }

  function initAll() {
    document.querySelectorAll('[data-kh]').forEach(function (root) {
      olcKampanya(root);
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-kh]').forEach(function (root) {
      olcKampanya(root);
      init(root);
    });
  });
})();
